import { isValidElement, type ReactElement, type ReactNode } from 'react';

/**
 * Compound components find their slot children by a static `slot` marker on the component
 * (`Title.slot = 'title'`) instead of by type identity (`child.type === Title`).
 * - Wrappers survive if they copy the marker: `PlatformActions.slot = 'actions'`.
 * - Same API, about 10 lines changed per component, and it is typed through this shared
 *   `isSlot(child, 'title')` helper.
 * - It still inspects children, so a wrapper around elements still fails: a component that
 *   renders `<Box.Title>` without carrying the marker lands in the content area.
 */
export function isSlot(child: ReactNode, slot: string): child is ReactElement {
    return isValidElement(child) && (child.type as { slot?: unknown }).slot === slot;
}
